import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  dialog: {
    width: '100% !important',
    maxWidth: '100% !important'
  },
  mainContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3)
  },
  headerContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    position: 'relative',
    marginBottom: theme.spacing(3),
    gap: theme.spacing(2),

    [theme.breakpoints.up('md')]: {
      justifyContent: 'space-between',
      flexDirection: 'row',
      margin: 0
    }
  },
  receiptTitle: {
    fontWeight: 600
  },
  stateContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(),
    alignSelf: 'center',
    alignItems: 'center',

    [theme.breakpoints.up('md')]: {
      position: 'absolute',
      alignSelf: 'flex-start',
      alignItems: 'flex-start',
      right: 0,
      top: 0
    }
  },
  stateTitle: {
    fontWeight: 500
  },
  button: {
    minWidth: 40,
    padding: '6px'
  },
  select: {
    width: 100,
    '& svg': {
      color: theme.palette.secondary.main
    },

    '& > div': {
      borderColor: theme.palette.primary.main,
      zIndex: 10,
      borderRadius: 0,
      boxShadow: '0px 4px 4px rgba(6, 0, 173, 0.15)'
    }
  },
  receiptReviewedButton: {
    backgroundColor: `${theme.utils.rgba(theme.palette.primary.main, 0.4)} !important`,
    color: `${theme.palette.primary.contrastText} !important`
  },
  textAreaEdit: {
    width: '100%',
    '& > div > textArea': {
      '&::placeholder': {
        color: 'rgba(105, 105, 105, 1)'
      },
      [theme.breakpoints.up('md')]: {
        minHeight: 50
      }
    },
    padding: theme.spacing(2, 0),
    '& fieldset': {
      borderColor: theme.palette.primary.main
    }
  },
  deleteButton: {
    position: 'absolute',
    right: 20,
    minWidth: 35,
    width: 35,
    bottom: 20,
    height: 35,
    [theme.breakpoints.up('md')]: {
      bottom: 30,
      right: 30
    }
  },
  deleteIcon: {
    width: 25,
    height: 25
  },
  progress: {
    '& svg': {
      width: 15,
      height: 15
    }
  },
  fileViewContainer: {
    height: '70vh !important'
  },
  cropper: {
    height: '57vh !important',
    marginTop: '0px !important',
    overflow: 'hidden'
  },
  fileContainer: {
    position: 'relative'
  },
  saveButton: {
    alignSelf: 'center',
    borderRadius: 10,
    width: 200,

    '& span': {
      fontSize: '1rem'
    }
  },
  commentInfo: {
    color: theme.palette.helperText.main,
    flexShrink: 0,
    fontSize: '.75rem'
  },
  commentDescription: {
    overflowWrap: 'anywhere',
    whiteSpace: 'pre-wrap'
  },
  arrowBackButton: {
    alignSelf: 'center',
    '& svg': {
      width: 50,
      height: 50
    }
  },

  receiptThumbList: {
    display: 'flex',
    gap: theme.spacing(),
    marginTop: theme.spacing(2),
    flexWrap: 'wrap',
    flexDirection: 'column',
    alignItems: 'center',

    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
      justifyContent: 'flex-start',
      width: 620,
      margin: '0 auto',
      marginTop: theme.spacing(4)
    }
  },

  receiptThumb: {
    width: 200,
    borderRadius: 8,
    border: '2px solid transparent',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    position: 'relative',

    '&:hover': {
      transform: 'translateY(-2px) scale(1.02)',
      borderColor: theme.palette.primary.main,
      boxShadow: `
      0 4px 12px rgba(25,118,210,0.35),
      0 0 0 1px rgba(25,118,210,0.4)
    `
    }
  },

  receiptThumbPreview: {
    height: 200,
    backgroundColor: theme.palette.alt.main,
    overflow: 'hidden',
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8
  },

  receiptThumbFooter: {
    padding: theme.spacing(0.5),
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column'
  },
  cropperOption: {
    height: 100,
    marginTop: theme.spacing(6)
  },
  container: {
    display: 'flex',
    flexDirection: 'column'
  },
  banner: {
    position: 'absolute',
    top: 8,
    left: 8,
    display: 'inline-flex',
    alignItems: 'center',
    height: 22,
    padding: '0 10px 0 12px',
    borderRadius: '4px 8px 8px 4px',
    transformOrigin: 'left center',
    animation: '$stretchIn 280ms cubic-bezier(.4,0,.2,1)',
    animationDelay: '180ms',
    animationFillMode: 'backwards',
    overflow: 'hidden',
    zIndex: 2,
    fontSize: theme.spacing(1.5),
    fontWeight: 600,
    whiteSpace: 'nowrap',
    color: theme.palette.secondary.contrastText,
    border: `1px solid ${theme.palette.secondary.contrastText}`
  },

  approvedBanner: {
    backgroundColor: theme.palette.secondary.main
  },
  pendingBanner: {
    backgroundColor: '#FAFD5C'
  },
  cancelledBanner: {
    backgroundColor: '#FF3629'
  },
  expiredBanner: {
    backgroundColor: theme.palette.disabled.main
  },

  '@keyframes stretchIn': {
    '0%': {
      transform: 'scaleX(0)',
      opacity: 0
    },
    '60%': {
      transform: 'scaleX(1)',
      opacity: 1
    },
    '100%': {
      transform: 'scaleX(1)'
    }
  },
  animateText: {
    opacity: 0,
    animation: '$textFadeIn 120ms ease-out forwards',
    animationDelay: '320ms'
  },
  '@keyframes textFadeIn': {
    from: {
      opacity: 0,
      transform: 'translateX(-4px)'
    },
    to: {
      opacity: 1,
      transform: 'translateX(0)'
    }
  },
  link: {
    fontWeight: 500,
    textDecoration: 'underline',
    cursor: 'pointer'
  },
  fileViewer: {
    height: 'auto',
    marginTop: theme.spacing(2),
    backgroundColor: 'transparent !important',
    '& > div > div > div:nth-of-type(1)': {
      display: 'none'
    }
  }
}))
